import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, MatchActionCreators, IPreselectReversalReportResponse } from '@nkr/store/index';
import { Button, FormControl, Well } from 'react-bootstrap';
import { HeaderWrapper } from './styles';
import { IBaseResponse, IPreReversalReport } from '@nkr/models/index';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPreselectReversalReport: (centerId: number, startDate: string, endDate: string) => Promise<IPreselectReversalReportResponse>,
    updateBillableCenter: (donorId: number, recipientId: number, reversalResponsible: number, prereversalId: number) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    [index: string]: string | number | IPreReversalReport[],
    startDate: string,
    endDate: string,
    month: number,
    centerId: number,
    report: IPreReversalReport[]
}

class PreselectReversalDetail extends React.Component<TProps, IState> {
    readonly state: IState = {
        startDate: '',
        endDate: '',
        month: 0,
        centerId: 0,
        report: []
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;
    }

    componentDidMount = () => {
        //get dates
        let startDate = '';
        let endDate = '';

        if (startDate == '' || endDate == '') {
            startDate = moment().startOf('month').format('YYYY-MM-DD');
            endDate = moment().endOf('month').format('YYYY-MM-DD');
        } else {
            startDate = this.state.startDate;
            endDate = this.state.endDate;
        }

        this.getData(startDate, endDate);
    }

    getData = (startDate: string, endDate: string) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getPreselectReversalReport(this.props.centerId, startDate, endDate)
                .then((response: IPreselectReversalReportResponse) => {
                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    getMonths = () => {
        let monthList: { index: number, name: string, startDate: string, endDate: string }[] = [];

        for (let m = 0; m < 12; m++) {
            let sd = moment().add(-1 * m, 'month').startOf('month');
            let ed = moment().add(-1 * m, 'month').endOf('month');

            let name = sd.format('MMMM YYYY');
            let startDate = sd.format('YYYY-MM-DD');
            let endDate = ed.format('YYYY-MM-DD');

            let v = { index: m, name, startDate, endDate };

            monthList.push(v);
        }

        return monthList;
    }

    handleSearch = () => {
        this.getData(this.state.startDate, this.state.endDate);
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handleMonthChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let index = parseInt(e.currentTarget.value);
        let months = this.getMonths();
        let month = months.find(x => x.index == index);

        this.setState({
            month: index
        }, () => {
            this.getData(month.startDate, month.endDate);
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'pre-reversal-detail.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    handleBillableCenterChange = (data: IPreReversalReport, reversalResponsible: number) => {
        this.props.showLoading('Updating responsible center, one moment please...').then(() => {
            this.props.updateBillableCenter(data.donorId, data.recipientId, reversalResponsible, data.id)
                .then((response: IBaseResponse) => {
                    if (response.data.success) {
                        this.getData(this.state.startDate, this.state.endDate);
                    } else {
                        this.props.hideLoading();
                    }
                }).catch((ex) => {
                    alert('An error occured while updating the billable center');
                    this.props.hideLoading();
                });
        });
    }

    render = () => {
        const months = this.getMonths();

        return (
            <>
                {this.props.isCenterLogin == false ?
                    <>
                        <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 20 }}>
                            Pre-Select Reversal Detail Report
                        </div>

                        <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='startDate'
                                            value={this.state.startDate}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>End Date:</div>
                                    <div>
                                        <FormControl
                                            type='date'
                                            name='endDate'
                                            value={this.state.endDate}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <Button bsStyle={'primary'} onClick={this.handleSearch}>Search</Button>
                                </div>
                            </div>

                            <div>
                                <Button onClick={this.handleExport}>Export CSV</Button>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4.5, paddingBottom: 4.5, marginBottom: 5 }}>
                            <div style={{ display: 'flex', fontSize: 12 }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5 }}>Month:&nbsp;</div>
                                    <div>
                                        <FormControl
                                            componentClass='select'
                                            bsSize='sm'
                                            name='endDate'
                                            value={this.state.month}
                                            onChange={this.handleMonthChange}
                                        >
                                            {months.map((month, index) =>
                                                <option key={'m-' + index} value={month.index}>{month.name}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <Button bsStyle='primary' bsSize='sm' onClick={this.handleExport}>Export CSV</Button>
                            </div>
                        </Well>
                    </>
                }

                <Grid data={this.state.report} isCenterLogin={this.props.isCenterLogin} onGridReady={this.onGridReady} onBillableCenterChange={this.handleBillableCenterChange} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPreselectReversalReport: (centerId, startDate, endDate) => {
            return dispatch(ReportActionCreators.getPreselectReversalReport(centerId, startDate, endDate));
        },
        updateBillableCenter: (donorId, recipientId, reversalResponsible, prereversalId) => {
            return dispatch(MatchActionCreators.updateBillableCenter(donorId, recipientId, reversalResponsible, prereversalId));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(PreselectReversalDetail);

